var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrameMixed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 22,
    viewBox: "0 0 82 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_19_402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.9511 16.7568C12.5934 16.1192 12.4145 15.5169 12.3429 14.8438C12.0209 15.2689 11.6274 15.6586 11.1981 15.942C10.4468 16.438 9.55236 16.686 8.51483 16.686H6.08203V5.24316H8.51483C9.55236 5.24316 10.4468 5.49114 11.1981 5.95169C11.9494 6.41224 12.5218 7.08535 12.9154 7.93559C13.3089 8.78583 13.4878 9.77778 13.4878 10.9114C13.4878 11.124 13.4878 11.3011 13.452 11.5137C13.7024 11.1948 14.0244 10.9469 14.3106 10.6634C14.3822 10.628 14.4538 10.5572 14.4895 10.5217C14.3822 10.4155 14.2749 10.2738 14.2033 10.1675C13.8456 9.70692 13.5951 9.2818 13.4162 8.89211C13.2731 8.50242 13.1658 8.04187 13.1658 7.58132C13.1658 6.76651 13.3447 6.05797 13.774 5.45572C14.1675 4.88889 14.7042 4.42834 15.4197 4.1095C15.9921 3.86151 16.6004 3.71981 17.2801 3.68438C16.5646 2.79871 15.6702 2.05475 14.6326 1.41707C13.0227 0.495974 10.9834 0 8.51483 0H0V21.9646H8.51483C10.7688 21.9646 12.7365 21.504 14.3822 20.6184C15.1335 20.2287 15.7775 19.7327 16.3857 19.2013C15.7775 19.095 15.2408 18.8824 14.7757 18.599C13.9887 18.1031 13.3805 17.5008 12.9511 16.7568Z",
    fill: "#A855F7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.7453 8.50242C17.9958 8.36071 18.1746 8.18357 18.3177 8.07729C18.4966 7.90016 18.5682 7.6876 18.5682 7.43961C18.5682 7.19163 18.4966 7.01449 18.3535 6.90821C18.2104 6.76651 18.0315 6.73108 17.8169 6.73108C17.638 6.73108 17.4949 6.76651 17.3876 6.83736C17.2802 6.90821 17.1729 7.01449 17.1013 7.12077C17.0298 7.22705 17.0298 7.36876 17.0298 7.51047C17.0298 7.6876 17.1013 7.86473 17.2087 8.00644C17.316 8.11272 17.4949 8.28986 17.7453 8.50242Z",
    fill: "#A855F7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M31.9842 0.0708618H25.1867L21.287 12.1159L22.1457 13.0016C22.1814 12.8953 22.2172 12.8245 22.253 12.7182C22.5392 11.9742 22.6465 11.0886 22.6465 10.0966H25.9738C25.9738 11.6554 25.7233 13.037 25.2225 14.2061C25.0078 14.7021 24.7931 15.1272 24.5427 15.5523C24.1849 16.1192 23.7914 16.6506 23.3263 17.0757C22.8254 17.5362 22.2888 17.9614 21.7164 18.2802C21.3944 18.4573 21.0366 18.6345 20.6788 18.7762C20.1064 18.9887 19.534 19.1304 18.9616 19.2367L18.0671 22.0354H24.328L25.0794 19.2013L25.4729 17.7134H31.7338L32.8787 22H39.068L31.9842 0.0708618ZM26.5462 13.7102L28.6212 5.98713L30.6963 13.7102H26.5462Z",
    fill: "#22D3EE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.6362 13.6747C16.4215 13.9227 16.3142 14.1707 16.3142 14.4541C16.3142 14.6667 16.3858 14.8792 16.4931 15.1272C16.6004 15.3752 16.8151 15.6232 17.1013 15.8003C17.3875 15.9775 17.7453 16.0837 18.2104 16.0837C18.3535 16.0837 18.4966 16.0837 18.6039 16.0483C18.8901 16.0129 19.1406 15.942 19.4268 15.8358L18.9617 15.3044L17.0655 13.285C16.8866 13.3913 16.7435 13.533 16.6362 13.6747Z",
    fill: "#A855F7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M39.6048 0L43.2183 14.9855L47.5115 0H53.9155L46.2593 21.9646H40.213L33.165 0H39.6048Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M55.5969 21.9646V0H61.6789V21.9646H55.5969Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M64.4338 17.4654L74.4871 5.24316H64.8989V0H81.8213V4.49919L72.3762 16.7214H82.0002V21.9646H64.4338V17.4654Z",
    fill: "#64748B"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameMixed);
export default __webpack_public_path__ + "static/media/Frame_mixed .1f4135c5b23fa103009fbbafeb37adfa.svg";
export { ForwardRef as ReactComponent };